import { graphicBuilderActionTypes } from '../actions/types';

const initialState = {
  canDrop: false,
};

export function graphicBuilder(state = initialState, action) {
  switch (action.type) {
    case graphicBuilderActionTypes.RESET_STATE:
      return {
        ...initialState,
      };
    case graphicBuilderActionTypes.CAN_DROP:
      return {
        ...state,
        canDrop: action.canDrop,
      };
    default:
      return state;
  }
}
